import React from "react";
import PropTypes from "prop-types";

import { InputStyled, Label } from "./styles";

function Input({
  as,
  disabled,
  error,
  handleBlur,
  handleFocus,
  handleChange,
  id,
  label,
  options,
  placeholder,
  type,
  maxLength,
  value,
  autoFocus,
}) {
  return (
    <div className="size-full text-left">
      {label !== "none" && (
        <Label htmlFor={id} $error={error}>
          {label || placeholder}
        </Label>
      )}
      <InputStyled
        autoComplete="new-password"
        disabled={disabled}
        $error={error}
        id={id}
        as={as}
        name={id}
        onBlur={() => handleBlur && handleBlur()}
        onFocus={() => handleFocus && handleFocus()}
        placeholder={placeholder}
        type={type}
        value={value}
        maxLength={maxLength}
        autoFocus={autoFocus}
        {...(handleChange ? { onChange: handleChange } : {})}
      >
        {options?.length &&
          options.map(({ label: optionLabel, value: optionValue }) => (
            <option key={optionValue} value={optionValue}>
              {optionLabel}
            </option>
          ))}
      </InputStyled>
    </div>
  );
}

Input.propTypes = {
  as: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  handleBlur: PropTypes.func,
  handleFocus: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoFocus: PropTypes.bool,
};

export default Input;
